<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">
            {{ $t('dtp.title') }} - {{ driverName }}
          </h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <dtp-table class="mt-4" :driver-id="$route.params.driverId" no-edit />
  </v-layout>
</template>

<script>
import DtpTable from '@/components/dtp/DtpTable.vue';

export default {
  components: { DtpTable },
  computed: {
    driverName() {
      return this.$store.getters['driver/getDriverName'];
    },
  },
};
</script>

<style></style>
